import { styled } from '../../utils';
export const Seperator = styled('div', {
    shouldForwardProp: (prop) => prop !== 'margin',
})(({ theme, margin }) => ({
    borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
    justifyItems: 'center',
    margin: typeof margin === 'string' ? margin : margin(theme),
}));
